import React from "react";
import { Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import EditIcon from "@material-ui/icons/Edit";
import Paper from "@material-ui/core/Paper";
import moment from "moment";

import { useUsersList } from "./usersListProvider";

const rowsPerPage = 50;

const publishedStatus = {
  not_published: "Nenhum",
  homepage: "Homepage",
  about_us: "Sobre nós",
};

const userName = (userId) => {
  const user = useUsersList().find((user) => user.id === userId);
  return user ? user.name : "";
};

const TestimonialsTable = ({ testimonials, type }) => {
  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Estado</TableCell>
            <TableCell>Localização</TableCell>
            <TableCell>Utilizador</TableCell>
            <TableCell>Título</TableCell>
            <TableCell>Testemunho</TableCell>
            <TableCell>Data de criação</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {testimonials &&
            testimonials.slice(0, rowsPerPage).map((testimonial, idx) => (
              <TableRow
                key={idx}
                style={
                  idx % 2
                    ? { background: "lightgray" }
                    : { background: "white" }
                }
              >
                <TableCell>{testimonial.id}</TableCell>
                <TableCell>{testimonial.status}</TableCell>
                <TableCell>
                  {publishedStatus[testimonial.published_status]}
                </TableCell>
                <TableCell>{userName(testimonial.user_id)}</TableCell>
                <TableCell>{testimonial.subject}</TableCell>
                <TableCell>{testimonial.message}</TableCell>
                <TableCell>
                  {moment(testimonial.created_at).format(
                    "YYYY-MM-DD [às] HH:mm"
                  )}
                </TableCell>
                <TableCell>
                  <Link to={`/testimonials/${type}/${testimonial.id}/edit`}>
                    <EditIcon />
                  </Link>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default TestimonialsTable;
